import React, {useContext, useState} from 'react'
import { Box, Button, Container, Typography, Grid } from '@material-ui/core'

import { useTextLookup } from 'utils/text'
import { useStyles } from 'styles/styles'
import AppContext from 'components/app/AppContext'
import AppHeader from 'components/widgets/AppHeader'
import Region from 'models/Region'
import LocaleSelector from 'components/widgets/LocaleSelector'

interface LandingPageProps {
    onSelectLocale: (locale: string) => void
    onSelectRegions: (regions: Region[]) => void
}

const LandingPage: React.FC<LandingPageProps> = (props) => {
    const classes = useStyles()
    const _t = useTextLookup()
    const appContext = useContext(AppContext)
    const [selected, setSelected] = useState({regions: new Set()})

    const handleSelectLocale = (locale: string) => {
        props.onSelectLocale(locale)
    }

    const handleRegionClick = (regionId: number) => {
        selected.regions.has(regionId) ? selected.regions.delete(regionId) : selected.regions.add(regionId)
        setSelected({ regions: selected.regions })
    }

    const handleContinueButton = () => {
        const regions = appContext.markets.flatMap(market => market.regions.filter(region => selected.regions.has(region.id)))
        props.onSelectRegions(regions)
        appContext.onNavigate(1)
    }
  
    return (
        <Box component="main">
            <Box className={classes.pageHeading}>
                <Container maxWidth="lg">
                    <AppHeader />
                    <Box display='flex' flexDirection="row" justifyContent='space-between' alignItems='flex-start'>
                        <Typography variant='h3' color='primary'>{_t("landing.title")}</Typography>
                        {appContext.locales.length > 1 &&
                            <LocaleSelector onSelectLocale={handleSelectLocale} />
                        }
                    </Box>
                    <Typography className={classes.paragraph}>{_t("landing.heading")}</Typography>
                </Container>
            </Box>
            <Box>
                <Container maxWidth="lg">
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={2}>
                            <Typography className={classes.paragraph} variant="h5" color='primary'>{_t("landing.side_title")}</Typography>
                            <Typography className={classes.paragraph}>{_t("landing.side_text")}</Typography>
                            <Box className={classes.buttonBar} display='flex' flexDirection='row' justifyContent='flex-start'>
                                <Button variant="contained" disabled={selected.regions.size === 0} onClick={handleContinueButton}>{_t("landing.button")}</Button>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={10}>
                            <Grid container spacing={1} className={classes.paragraph}>
                                {appContext.markets.map(market =>
                                    <Grid item key={market.id} xs={12} md={4} >
                                        <Typography className={classes.flagMarketName}>{market.name}</Typography>
                                        <Grid container spacing={1}>
                                            {market.regions.map(region =>
                                                <Grid item key={region.id} xs={6} onClick={() => handleRegionClick(region.id)}>
                                                    <Box display="flex" flexDirection="column" className={selected.regions.has(region.id) ? classes.flagSelected : classes.flagDeselected}>
                                                        <img style={{ width: '100%', height: 'auto'}} src={region.flagImage} alt={`${region.name} flag`} />
                                                        <Typography className={classes.flagLabel} variant="body2">{region.name} ({region.code})</Typography>
                                                    </Box>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </Box>
    )
}

export default LandingPage
